// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/dist/cjs.js??ref--10-oneOf-3-1!../../../postcss-loader/src/index.js??ref--10-oneOf-3-2!../../../sass-loader/dist/cjs.js??ref--10-oneOf-3-3!./main.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("c2aa8216", content, false, {"sourceMap":false,"shadowMode":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/dist/cjs.js??ref--10-oneOf-3-1!../../../postcss-loader/src/index.js??ref--10-oneOf-3-2!../../../sass-loader/dist/cjs.js??ref--10-oneOf-3-3!./main.sass", function() {
     var newContent = require("!!../../../css-loader/dist/cjs.js??ref--10-oneOf-3-1!../../../postcss-loader/src/index.js??ref--10-oneOf-3-2!../../../sass-loader/dist/cjs.js??ref--10-oneOf-3-3!./main.sass");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}